import React from 'react';
import PropTypes from 'prop-types';
import {CircularProgress} from '@material-ui/core';
import { PieChart } from 'react-minimal-pie-chart';
import Button from "../Button/Button";
import {Link} from 'react-router-dom';

const DashboardStatsCard = ({className, title, text, linkTo, loading, urlTo, chart, progres, button}) => {
  const getContent = () => {
    const content = (
      <>
        <h5 className="card-title text-center">{title}</h5>
        <p className="card-text text-center">{text}</p>
      </>
    );

    if (loading) {
      return (
        <div className="d-flex justify-content-center">
          <CircularProgress size={28} />
        </div>
      );
    }

    if (linkTo) {
      return (
        <Link to={linkTo}>
          {content}
        </Link>
      );
    }

    if (urlTo) {
      return (
        <a href={urlTo} target="_blank" rel="noreferrer">
          {content}
        </a>
      );
    }

    if (chart) {
      return (
        <>
          <h5 className="card-title text-center">{title}</h5>
          <div class="mt-3">
            <PieChart
              data={chart}
              lineWidth={42}
              label={({ dataEntry }) => `${Math.round(dataEntry.percentage)}%`}
              labelStyle={{ fontSize: '5px', fill: '#fff' }}
              labelPosition={70}
              animate
            />
          </div>
        </>
      );
    }

    if (progres) {
      const containerStyles = {
        height: '10px',
        width: '100%',
        backgroundColor: '#E0E0DE',
        borderRadius: '5px',
        overflow: 'hidden',
      };
  
      const fillerStyles = {
        height: '100%',
        width: `${progres.percentage}%`,
        backgroundColor: '#4F46E5',
        transition: 'width 0.5s ease-in-out',
      };
  
      return (
        <>
          <h5 className="card-title text-center">{title}</h5>
          <p className="card-text text-center" style={{ marginTop: "30px" }}>{progres.topText}</p>

          <div class="mt-3 mb-3">
            <div style={containerStyles}>
              <div style={fillerStyles}></div>
            </div>
          </div>
          
          <p className="card-text text-center">{progres.bottomText1}</p>
          <p className="card-text text-center">{progres.bottomText2}</p>
          { progres?.bottomText3 && (<p className="card-text text-center">{progres.bottomText3}</p>)}
        </>
      );
    }

    if (button) {
      return (
        <>
          <h5 className="card-title text-center">{title}</h5>
          <p className="card-text text-center" style={{ marginTop: "30px" }}>
            <Button
              generalType="default-outlined"
              className="ml-2"
              type="button"
              onClick={button.click}
            >
              <i className={`mdi ${button.icon}`}> { button.text } </i>
            </Button>
          </p>
        </>
      );
    }

    return content;
  };

  return (
    <div className={`card dashboard-stats-card ${className}`}>
      <div className="card-body">
        { getContent() }
      </div>
    </div>
  );
};

DashboardStatsCard.defaultProps = {
  className: 'bg-gray',
  loading: false,
};

DashboardStatsCard.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.number]),
  linkTo: PropTypes.string,
  loading: PropTypes.bool,
};

export default DashboardStatsCard;
